function $5a247dee9f436983$export$ac262bcf0e49db26() {
    const button = document.querySelector(".menu");
    const navigation = document.querySelector(".nav");
    button.addEventListener("click", ()=>{
        navigation.classList.toggle("show-nav");
    });
}
function $5a247dee9f436983$export$d23fdc9d41d1a258() {
    const navLinks = document.querySelectorAll(".nav ul li a");
    const navigation = document.querySelector(".nav");
    navLinks.forEach((link)=>{
        link.addEventListener("click", ()=>{
            navigation.classList.remove("show-nav");
        });
    });
}


let $692f6db1a7de4e3f$var$particleConfig = {
    particles: {
        number: {
            value: 80,
            density: {
                enable: true,
                value_area: 800
            }
        },
        color: {
            value: "#e95d5d"
        },
        shape: {
            type: "circle",
            stroke: {
                width: 0,
                color: getComputedStyle(document.documentElement).getPropertyValue("--primary")
            },
            polygon: {
                nb_sides: 5
            },
            image: {
                src: "img/github.svg",
                width: 100,
                height: 100
            }
        },
        opacity: {
            value: 1,
            random: true,
            anim: {
                enable: true,
                speed: 1,
                opacity_min: 0,
                sync: false
            }
        },
        size: {
            value: 3,
            random: true,
            anim: {
                enable: false,
                speed: 4,
                size_min: 0.3,
                sync: false
            }
        },
        line_linked: {
            enable: false,
            distance: 150,
            color: "#ffffff",
            opacity: 0.4,
            width: 1
        },
        move: {
            enable: true,
            speed: 0.25,
            direction: "none",
            random: true,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
                enable: false,
                rotateX: 600,
                rotateY: 600
            }
        }
    },
    interactivity: {
        detect_on: "canvas",
        events: {
            onhover: {
                enable: true,
                mode: "repulse"
            },
            onclick: {
                enable: true,
                mode: "repulse"
            },
            resize: true
        },
        modes: {
            grab: {
                distance: 400,
                line_linked: {
                    opacity: 1
                }
            },
            bubble: {
                distance: 250,
                size: 0,
                duration: 2,
                opacity: 0,
                speed: 3
            },
            repulse: {
                distance: 400,
                duration: 0.4
            },
            push: {
                particles_nb: 4
            },
            remove: {
                particles_nb: 2
            }
        }
    },
    retina_detect: true
};
function $692f6db1a7de4e3f$export$dfb9fdde960d9663() {
    document.addEventListener("DOMContentLoaded", ()=>{
        particlesJS("particles-js", $692f6db1a7de4e3f$var$particleConfig);
    });
}
function $692f6db1a7de4e3f$export$eaec34c7c48265e8() {
    $692f6db1a7de4e3f$var$particleConfig.particles.color.value = getComputedStyle(document.documentElement).getPropertyValue("--primary");
    particlesJS("particles-js", $692f6db1a7de4e3f$var$particleConfig);
}


const $716aa5be9c2c3d10$var$themes = {
    light: [
        "light",
        "pink-light",
        "blue-light",
        "green-light",
        "purple-light",
        "orange-light"
    ],
    dark: [
        "dark",
        "pink-dark",
        "blue-dark",
        "green-dark",
        "purple-dark",
        "orange-dark"
    ]
};
function $716aa5be9c2c3d10$var$getBaseTheme(currentTheme) {
    if ($716aa5be9c2c3d10$var$themes.dark.includes(currentTheme)) return "dark";
    return "light";
}
function $716aa5be9c2c3d10$var$toggleThemeVariant(currentTheme) {
    if (currentTheme.includes("light")) return currentTheme.replace("light", "dark");
    else if (currentTheme.includes("dark")) return currentTheme.replace("dark", "light");
    return currentTheme === "light" ? "dark" : "light";
}
function $716aa5be9c2c3d10$var$moveThemeToggleButton() {
    const themeToggleButton = document.querySelector(".switch");
    const parentMobile = document.querySelector(".theme-switch-mobile");
    const parentDesktop = document.querySelector(".theme-switch");
    if (window.innerWidth < 1100) {
        if (!parentMobile.contains(themeToggleButton)) {
            parentDesktop.removeChild(themeToggleButton);
            parentMobile.appendChild(themeToggleButton);
        }
    } else if (window.innerWidth > 1100) {
        if (!parentDesktop.contains(themeToggleButton)) {
            parentMobile.removeChild(themeToggleButton);
            parentDesktop.appendChild(themeToggleButton);
        }
    }
}
function $716aa5be9c2c3d10$export$ff2bb4e9ce0a4b43() {
    document.addEventListener("DOMContentLoaded", ()=>{
        const themeToggleButtons = document.querySelectorAll(".theme-toggle");
        const storedTheme = localStorage.getItem("theme") || "dark";
        const baseTheme = $716aa5be9c2c3d10$var$getBaseTheme(storedTheme);
        window.addEventListener("resize", $716aa5be9c2c3d10$var$moveThemeToggleButton);
        window.addEventListener("load", $716aa5be9c2c3d10$var$moveThemeToggleButton);
        document.documentElement.setAttribute("data-theme", baseTheme);
        localStorage.setItem("theme", baseTheme);
        themeToggleButtons.forEach((button)=>{
            button.addEventListener("click", ()=>{
                const currentTheme = document.documentElement.getAttribute("data-theme");
                const newTheme = $716aa5be9c2c3d10$var$toggleThemeVariant(currentTheme);
                document.documentElement.setAttribute("data-theme", newTheme);
                localStorage.setItem("theme", newTheme);
                (0, $692f6db1a7de4e3f$export$eaec34c7c48265e8)();
            });
        });
    });
}
function $716aa5be9c2c3d10$export$118008e8ff37ec72() {
    document.addEventListener("DOMContentLoaded", ()=>{
        const button = document.querySelector(".secret-themes-button");
        let currentIndex = 0;
        button.addEventListener("click", ()=>{
            const currentTheme = document.documentElement.getAttribute("data-theme");
            const baseTheme = $716aa5be9c2c3d10$var$getBaseTheme(currentTheme);
            const themeList = $716aa5be9c2c3d10$var$themes[baseTheme];
            currentIndex = themeList.indexOf(currentTheme);
            const newTheme = themeList[(currentIndex + 1) % themeList.length];
            document.documentElement.setAttribute("data-theme", newTheme);
            localStorage.setItem("theme", newTheme);
            (0, $692f6db1a7de4e3f$export$eaec34c7c48265e8)();
        });
    });
}


function $0bfce9578acf8ed7$export$dc054af7d2d5f30() {
    document.addEventListener("scroll", function() {
        const headerCenterContainer = document.querySelector("header .center-container");
        const innerContainer = document.querySelector("header .inner-container");
        if (window.innerWidth >= 1100) {
            if (window.scrollY > 50) {
                headerCenterContainer.classList.add("shrink");
                innerContainer.classList.add("shrink");
            } else {
                headerCenterContainer.classList.remove("shrink");
                innerContainer.classList.remove("shrink");
            }
        } else if (window.scrollY > 50) {
            headerCenterContainer.classList.add("shrink");
            innerContainer.classList.add("shrink");
        } else {
            headerCenterContainer.classList.remove("shrink");
            innerContainer.classList.remove("shrink");
        }
    });
}


function $df7718dea40c34a7$export$7a4a9639b38b0ee() {
    document.addEventListener("DOMContentLoaded", (event)=>{
        const dynamicText = document.getElementById("occupation");
        const phrases = [
            "Web Developer",
            "Full-Stack Developer",
            "Web Designer"
        ];
        let index = 0;
        let isDeleting = false;
        let charIndex = 0;
        let isPaused = false;
        let typingTimeout;
        let currentText = "";
        function type() {
            const fullText = phrases[index];
            if (isDeleting) {
                currentText = fullText.substring(0, charIndex - 1);
                charIndex--;
            } else {
                currentText = fullText.substring(0, charIndex + 1);
                charIndex++;
            }
            dynamicText.textContent = currentText;
            if (!isDeleting && charIndex === fullText.length) setTimeout(()=>{
                isDeleting = true;
                type();
            }, 500);
            else if (isDeleting && charIndex === 0) {
                isDeleting = false;
                index = (index + 1) % phrases.length;
                type();
            } else {
                const typingSpeed = isDeleting ? 50 : 100;
                typingTimeout = setTimeout(type, typingSpeed);
            }
        }
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    if (isPaused) {
                        isPaused = false;
                        type();
                    }
                } else {
                    isPaused = true;
                    clearTimeout(typingTimeout);
                }
            });
        });
        observer.observe(dynamicText);
        type();
    });
}


function $f9fcfd84066261de$export$99e00de73f33b819() {
    document.addEventListener("DOMContentLoaded", function() {
        const carousels = [
            {
                sliderId: "languages-slider",
                prevButtonId: "languages-prev",
                nextButtonId: "languages-next"
            },
            {
                sliderId: "programs-slider",
                prevButtonId: "programs-prev",
                nextButtonId: "programs-next"
            }
        ];
        carousels.forEach(({ sliderId: sliderId, prevButtonId: prevButtonId, nextButtonId: nextButtonId })=>{
            const slider = document.getElementById(sliderId);
            const prevButton = document.getElementById(prevButtonId);
            const nextButton = document.getElementById(nextButtonId);
            const slideTrack = slider.querySelector(".skills-slide-track");
            const slides = slider.querySelectorAll(".skills-slide");
            let currentIndex = 0;
            let autoSlideInterval;
            let autoSlideTimeout;
            const autoSlideDelay = 2000; // 2 seconds
            const resumeDelay = 5000; // 5 seconds
            let isAutoSliding = false;
            let startX, endX;
            function updateCarousel() {
                const width = slides[0].clientWidth;
                slideTrack.style.transform = `translateX(-${currentIndex * width}px)`;
            }
            function resetCarousel() {
                currentIndex = 0;
                slideTrack.style.transition = "none";
                slideTrack.style.transform = "none";
                setTimeout(()=>{
                    slideTrack.style.transition = "transform 0.5s ease";
                }, 50);
                clearInterval(autoSlideInterval);
                autoSlideInterval = null;
            }
            function nextSlide() {
                if (currentIndex < slides.length - 1) currentIndex++;
                else currentIndex = 0;
                updateCarousel();
            }
            function prevSlide() {
                if (currentIndex > 0) currentIndex--;
                else currentIndex = slides.length - 1;
                updateCarousel();
            }
            function startAutoSlide() {
                if (!isAutoSliding && window.innerWidth < 800) {
                    isAutoSliding = true;
                    autoSlideInterval = setInterval(nextSlide, autoSlideDelay);
                }
            }
            function stopAutoSlide() {
                isAutoSliding = false;
                clearInterval(autoSlideInterval);
                autoSlideInterval = null;
            }
            function resetAutoSlideTimeout() {
                clearTimeout(autoSlideTimeout);
                autoSlideTimeout = setTimeout(startAutoSlide, resumeDelay);
            }
            function handleSwipe() {
                const swipeDistance = endX - startX;
                if (Math.abs(swipeDistance) > 50) {
                    if (swipeDistance > 0) prevSlide();
                    else nextSlide();
                    if (window.innerWidth < 800) {
                        stopAutoSlide();
                        resetAutoSlideTimeout();
                    }
                }
            }
            prevButton.addEventListener("click", function() {
                if (window.innerWidth < 800) {
                    stopAutoSlide();
                    prevSlide();
                    resetAutoSlideTimeout();
                } else prevSlide();
            });
            nextButton.addEventListener("click", function() {
                if (window.innerWidth < 800) {
                    stopAutoSlide();
                    nextSlide();
                    resetAutoSlideTimeout();
                } else nextSlide();
            });
            window.addEventListener("resize", function() {
                if (window.innerWidth >= 800) {
                    stopAutoSlide();
                    resetCarousel();
                } else if (!autoSlideInterval) {
                    resetCarousel();
                    startAutoSlide();
                }
            });
            slider.addEventListener("touchstart", function(event) {
                startX = event.touches[0].clientX;
            });
            slider.addEventListener("touchmove", function(event) {
                endX = event.touches[0].clientX;
            });
            slider.addEventListener("touchend", function() {
                handleSwipe();
            });
            if (window.innerWidth < 800) startAutoSlide();
            updateCarousel();
        });
    });
}


function $1b99cc9a4e7a9427$var$updateStyles() {
    const targetHref = 'styles.css';
    for(let i = 0; i < document.styleSheets.length; i++){
        let sheet = document.styleSheets[i];
        if (sheet.href && sheet.href.includes(targetHref)) try {
            let rules = sheet.cssRules;
            if (rules) for(let j = 0; j < rules.length; j++){
                let rule = rules[j];
                if (rule.type === CSSRule.STYLE_RULE) {
                    if (window.innerWidth <= 800 && rule.selectorText.includes(':hover')) {
                        let newSelector = rule.selectorText.replace(':hover', ':active');
                        let newRule = `${newSelector} { ${rule.style.cssText} }`;
                        sheet.insertRule(newRule, sheet.cssRules.length);
                        sheet.deleteRule(j);
                    } else if (window.innerWidth > 800 && rule.selectorText.includes(':active')) {
                        let newSelector = rule.selectorText.replace(':active', ':hover');
                        let newRule = `${newSelector} { ${rule.style.cssText} }`;
                        sheet.insertRule(newRule, sheet.cssRules.length);
                        sheet.deleteRule(j);
                    }
                }
            }
        } catch (e) {
            console.warn("Cannot access stylesheet: " + sheet.href);
        }
    }
}
function $1b99cc9a4e7a9427$export$a48d2b7a9668956e() {
    window.addEventListener('load', $1b99cc9a4e7a9427$var$updateStyles);
    window.addEventListener('resize', $1b99cc9a4e7a9427$var$updateStyles);
}



(0, $f9fcfd84066261de$export$99e00de73f33b819)();
(0, $5a247dee9f436983$export$ac262bcf0e49db26)();
(0, $5a247dee9f436983$export$d23fdc9d41d1a258)();
(0, $716aa5be9c2c3d10$export$ff2bb4e9ce0a4b43)();
(0, $0bfce9578acf8ed7$export$dc054af7d2d5f30)();
(0, $df7718dea40c34a7$export$7a4a9639b38b0ee)();
(0, $716aa5be9c2c3d10$export$118008e8ff37ec72)();
(0, $1b99cc9a4e7a9427$export$a48d2b7a9668956e)();
(0, $692f6db1a7de4e3f$export$dfb9fdde960d9663)();
const $77ac944da51b7354$var$backToTopButton = document.querySelector(".back-to-top-button");
window.addEventListener("scroll", $77ac944da51b7354$var$checkIfBottom);
window.addEventListener("resize", $77ac944da51b7354$var$checkIfBottom);
window.addEventListener("scroll", ()=>{
    if (window.scrollY > 500) $77ac944da51b7354$var$backToTopButton.classList.add("show-back-to-top-button");
    else $77ac944da51b7354$var$backToTopButton.classList.remove("show-back-to-top-button");
});
function $77ac944da51b7354$var$isBottomOfPage() {
    let scrollPosition = window.scrollY;
    let documentHeight = document.documentElement.scrollHeight;
    let windowHeight = window.innerHeight;
    return windowHeight + scrollPosition >= documentHeight - 1;
}
function $77ac944da51b7354$var$checkIfBottom() {
    if ($77ac944da51b7354$var$isBottomOfPage()) {
        document.querySelector("#socials").style.visibility = "hidden";
        document.querySelector("#socials").style.opacity = "0";
    } else {
        document.querySelector("#socials").style.visibility = "visible";
        document.querySelector("#socials").style.opacity = "1";
    }
}
const $77ac944da51b7354$var$readMoreButtons = document.querySelectorAll(".read-more-button");
const $77ac944da51b7354$var$readLessButtons = document.querySelectorAll(".read-less-button");
$77ac944da51b7354$var$readMoreButtons.forEach((button)=>{
    button.addEventListener("click", function() {
        const card = this.closest(".portfolio-card");
        const readLessButton = card.querySelector(".read-less-button");
        const readMoreButton = card.querySelector(".read-more-button");
        const readMoreContents = card.querySelector(".read-more");
        readMoreContents.style.display = "unset";
        readMoreButton.style.display = "none";
        readLessButton.style.display = "unset";
    });
});
$77ac944da51b7354$var$readLessButtons.forEach((button)=>{
    button.addEventListener("click", function() {
        const card = this.closest(".portfolio-card");
        const readMoreButton = card.querySelector(".read-more-button");
        const readLessButton = card.querySelector(".read-less-button");
        const readMoreContents = card.querySelector(".read-more");
        readMoreContents.style.display = "none";
        readMoreButton.style.display = "unset";
        readLessButton.style.display = "none";
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const portfolioContainer = document.querySelector(".portfolio-container");
    const portfolioCards = document.querySelectorAll(".portfolio-card");
    const toggleButton = document.querySelector(".toggle-projects-button");
    const cardsToShow = 6;
    let isExpanded = false;
    // Initial hide of extra cards
    portfolioCards.forEach((card, index)=>{
        if (index >= cardsToShow) card.style.display = "none";
        else card.style.display = "flex";
    });
    // Toggle button functionality
    toggleButton.addEventListener("click", ()=>{
        isExpanded = !isExpanded;
        portfolioCards.forEach((card, index)=>{
            if (index >= cardsToShow) card.style.display = isExpanded ? "flex" : "none";
        });
        toggleButton.textContent = isExpanded ? "Show Less Projects" : "Show More Projects";
    });
});


//# sourceMappingURL=index.d580b0ea.js.map
